import { SyncLogStatusAlert } from '../../sync/components/sync-log-status-alert';
import type { PartnerSyncDataType } from '../types';

export function PartnerSyncStatus({ dataTypes }: { dataTypes: PartnerSyncDataType[] }) {
  return (
    <div className="flex items-center p-4">
      <div className="flex w-full flex-col gap-2">
        {dataTypes.map((dataType) => (
          <SyncLogStatusAlert
            key={dataType}
            syncFor={{ integration: 'integration-erp', dataType }}
            allowViewErrors={true}
          />
        ))}
      </div>
    </div>
  );
}
